import React, {useEffect, useState, useCallback} from 'react';
import PatternOptions from './PatternOptions.js';
import SamplerTrigger from './SamplerTrigger.js';
import SampleOptions from './SampleOptions.js';
import PrettyWaveform from 'components/waveform/PrettyWaveform';
import WorkVolume from './WorkVolume.js';

export default ({sequencerEngine, samplersLoaded, deleteSample}) => {
    const [recording, setRecording] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [lastClicked, setLastClicked] = useState(undefined);

    useEffect(() => {
        if (samplersLoaded[0]) {
            let _sequencerEngine = samplersLoaded[0].sequencerEngine;
            _sequencerEngine.deleting = deleting;
        }
    }, [deleting, samplersLoaded]);

    const onClickRecording = useCallback(() => {
        setRecording(!recording);
    }, [recording, setRecording]);

    if (samplersLoaded.length === 0) {
        return [];
    }

    let waveform = '';
    if (lastClicked) {
        let {instrument} = lastClicked;
        waveform = (
            <PrettyWaveform
              instrument={instrument}
              color={"#ffffff"}
              sampler={instrument.defaultSampler}
              soundId={instrument.defaultSampler.sample.getId()}
              buffer={instrument.defaultSampler.sample.audioBuffer}
              width={150}
              height={40}
            />
        );
    }
    return (
        <div className="sampler">
          <div className="inner">
            <WorkVolume
              multiSequencerEngine={sequencerEngine}
              sequencerEngine={samplersLoaded[0].sequencerEngine}
              id={samplersLoaded[0].sequencerEngine.sequenceId}/>
            <div className="sampler-triggers">
              {samplersLoaded.map(
                  track =>
                      <SamplerTrigger
                        key={track.id}
                        recording={recording}
                        selected={lastClicked === track}
                        setLastClicked={setLastClicked}
                        track={track}/>)}
            </div>
            <div className="right-side">
              {waveform}
              <SampleOptions
                deleteSample={() => {
                    setLastClicked(undefined);
                    deleteSample(lastClicked);
                }}
                lastClicked={lastClicked}/>
            </div>
          </div>
          <PatternOptions
            setDeleting={setDeleting}
            deleting={deleting}
            recording={recording}
            onClickRecord={onClickRecording}/>
       </div>
    );
}


